import { useMemo } from 'react';
import type React from 'react';

import { Box } from '@change-corgi/design-system-legacy/layout';

import type { OnlineShareChannel } from 'src/app/pages/starterDashboard/shared/types';
import { ShareButton } from 'src/app/shared/components/share';
import type { ShareAction } from 'src/app/shared/hooks/share';

import { SHARE_BUTTON_CONFIG } from '../../../useDashboardShareActions/constants';

type OnlineShareAction = ShareAction<OnlineShareChannel>;
type Props = { actions: readonly OnlineShareAction[] };

function Button({ action, index }: { action: OnlineShareAction; index: number }) {
	const { channel } = action;

	const { label, successLabel } = SHARE_BUTTON_CONFIG[channel];

	const buttonConfig = useMemo(
		() => ({
			...action,
			label,
			successLabel,
		}),
		[action, label, successLabel],
	);

	return (
		<Box
			as="li"
			role="listitem"
			data-qa={`sfs-${channel}-button`}
			sx={{ gridColumn: index === 0 ? 'span 2' : undefined }}
		>
			<ShareButton buttonConfig={buttonConfig} />
		</Box>
	);
}

export const ActionItems: React.FC<Props> = ({ actions }) => {
	return (
		<Box
			as="ul"
			role="list"
			sx={{
				display: 'grid',
				gridGap: 12,
				mt: 24,
				gridTemplateColumns: '1fr 1fr',
			}}
		>
			{actions.map((action, index) => (
				<Button key={action.channel} action={action} index={index} />
			))}
		</Box>
	);
};
